import { getAuthToken, getChatToken } from "./authTokens";

type HeaderOptions = {
  includeChatToken?: boolean;
};

export const applyAuthHeaders = (headers: Headers, options?: HeaderOptions) => {
  const token = getAuthToken();
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  if (options?.includeChatToken) {
    const chatToken = getChatToken();
    if (chatToken) {
      headers.set("chat_token", chatToken);
    }
  }

  return headers;
};

export const buildAxiosHeaders = (
  extraHeaders?: Record<string, string>,
  options?: HeaderOptions
) => {
  const headers: Record<string, string> = { ...(extraHeaders || {}) };
  const token = getAuthToken();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  if (options?.includeChatToken) {
    const chatToken = getChatToken();
    if (chatToken) {
      headers["chat_token"] = chatToken;
    }
  }

  return { headers };
};
